import React from 'react'
import { useFundActionPlanGrid, useFundActionPlanTable } from '../hooks/useFundActionPlan'
import { Grid, Popover, Typography } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import DataGrid from 'components/DataGrid';
import FilterFundActionPlan from './FilterFundActionPlan';

const FundActionPlanList = () => {
  const { form, dataRow, onGetData, onClear, onAddForm, onDelete, isLoading } = useFundActionPlanTable();
  const { dataColumn, open, anchorEl, handleClose, sUpdateName, isPermission } = useFundActionPlanGrid();
  return (
    <FormProvider {...form}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FilterFundActionPlan
            onSearch={() => onGetData(dataRow)}
            onClear={() => onClear()}
            onAddForm={() => onAddForm()}
          />
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            sTableID="tableIndicatorForm"
            columns={dataColumn}
            rows={dataRow}
            modeFilter={0}
            isLoading={isLoading}
            onLoadData={(e) => onGetData(e)}
            isShowCheckBox={isPermission}
            onDelete={(d) => onDelete(d)}
            isHiddenToolHead
          />
        </Grid>
      </Grid>

      {/* pop over UserUpdate */}
      <Popover
        id={`sUpdateName`}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Typography sx={{ p: 2 }}>{sUpdateName}</Typography>
      </Popover>
    </FormProvider>
  )
}

export default FundActionPlanList